import {AssetsRequestParams} from "../../infrastructure/models/params/assets-request-params";

export class SearchImageRequestParams extends AssetsRequestParams {
  constructor(width: Number,height: Number) {
    super(width, height);

    this.resourceName = this.resourceName + '/Search';
    this.c = null;
    this.ratio = 3
  }
}
